import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    //RCTI PAGE VALUES
    selected: [],
    bills: [],
    dates: [],
    filterBy: '',
    filterCol: '',
    selectedAll: false
    // defaultHeaders: [
    //     'id',
    //     'date',
    //     'externalRef',
    //     'project.name',
    //     'total',
    //     'siteWeightTotal',
    //     'trips',
    //     'status',
    //     'user.email'
    // ],
  },
  mutations: Mutations,
  actions: {},
  getters: {}
}
